import { ofType, Epic, combineEpics } from "redux-observable";
import { merge, of } from "rxjs";
import { catchError, map, mergeMap, takeUntil } from "rxjs/operators";
import { selectAuthTokens } from "../../../features/auth/selectors/auth.selector";
import { IAction } from "../../../interface/action.interface";
import { IErrorDto } from "../../../interface/dto/error.dto";
import { IRootState } from "../../../redux/root.reducer";
import { updateTrackList } from "../../../service/list-update-tracking.api";
import { getTrackedList } from "../../../service/tracked-list.api";
import { selectFiltersAndPagination } from "../selectors/filters-and-pagination";
import { listToTrackEpic } from "./list-to-track/list-to-track.epic";
import {
    ITrackedListActions,
    TrackedListActionTypes,
    trackedListLoadErrorAction,
    trackedListLoadSuccessAction,
    trackedListTrackErrorAction,
    trackedListTrackSuccessAction,
    trackedListLoadAction,
} from "./tracked-lists.actions";

const trackedListTableEpic: Epic<IAction, IAction, IRootState> = (
    action$,
    state$,
) =>
    merge(
        action$.pipe(
            ofType(TrackedListActionTypes.TRACKED_LIST_INIT),
            map(trackedListLoadAction),
        ),
        action$.pipe(
            ofType<
                ITrackedListActions,
                TrackedListActionTypes.TRACKED_LIST_LOAD_LISTS
            >(TrackedListActionTypes.TRACKED_LIST_LOAD_LISTS),
            mergeMap(() =>
                getTrackedList(
                    selectFiltersAndPagination(state$.value),
                    selectAuthTokens(),
                ).pipe(
                    takeUntil(
                        action$.pipe(
                            ofType(
                                TrackedListActionTypes.TRACKED_LIST_LOAD_LISTS,
                            ),
                        ),
                    ),
                    map((response) => trackedListLoadSuccessAction(response)),
                    catchError((error: IErrorDto) =>
                        of(trackedListLoadErrorAction(error.message)),
                    ),
                ),
            ),
        ),
        action$.pipe(
            ofType<
                ITrackedListActions,
                TrackedListActionTypes.TRACKED_LIST_TRACK
            >(TrackedListActionTypes.TRACKED_LIST_TRACK),
            mergeMap(({ payload }) =>
                updateTrackList(
                    payload.id,
                    payload.track,
                    selectAuthTokens(),
                ).pipe(
                    takeUntil(
                        action$.pipe(
                            ofType(TrackedListActionTypes.TRACKED_LIST_TRACK),
                        ),
                    ),
                    map((result) =>
                        result
                            ? trackedListTrackSuccessAction()
                            : trackedListTrackErrorAction(
                                  "Error while setting up list tracking!!",
                              ),
                    ),
                    catchError((error: IErrorDto) =>
                        of(trackedListTrackErrorAction(error.message)),
                    ),
                ),
            ),
        ),
        action$.pipe(
            ofType<
                ITrackedListActions,
                | TrackedListActionTypes.TRACKED_LIST_SET_SEARCHQUERY
                | TrackedListActionTypes.TRACKED_LIST_SET_PAGINATION
                | TrackedListActionTypes.TRACKED_LIST_SET_SORTING
                | TrackedListActionTypes.TRACKED_LIST_TRACK_SUCCESS
            >(
                TrackedListActionTypes.TRACKED_LIST_TRACK_SUCCESS,
                TrackedListActionTypes.TRACKED_LIST_SET_PAGINATION,
                TrackedListActionTypes.TRACKED_LIST_SET_SORTING,
                TrackedListActionTypes.TRACKED_LIST_SET_SEARCHQUERY,
            ),
            map(trackedListLoadAction),
        ),
    );
export const trackedListEpic = combineEpics(
    trackedListTableEpic,
    listToTrackEpic,
);
